<div class="title-with-divider" [ngClass]="{ 'title-with-margin': titlewithmargin}">
  <div class="title">
    <ng-content>{{ Title }}</ng-content>
  </div>
</div>
